import {
  Box,
  Button,
  useTheme,
  useMediaQuery,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { tokens } from "../../theme";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import Header from "../../components/Header";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import SearchTable from "../../components/SearchTable";
import PollModal from "../../components/modals/PollModal";
import OptionsModal from "../../components/modals/OptionsModal";

const ManagePoll = () => {
  const [details, setDetails] = useState([]);
  const [newDetails, setNewDetails] = useState([]);
  const [modal, setModal] = useState({ open: false });
  const [optionsModal, setOptionsModal] = useState({ open: false });
  const [pollOptions, setPollOptions] = useState([]);
  const { cookies } = useAuth();
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const colors = tokens(theme.palette.mode);
  const axiosPrivate = useAxiosPrivate();

  const getPolls = async () => {
    try {
      const response = await axiosPrivate.get(
        "https://services.staging.wayagram.ng/wayagram-service/all-posts/admin-get-polls",
        {
          params: {
            page: 1,
            limit: 20,
            sso_id: cookies?.auth?.user?.id,
          },
        }
      );
      setDetails(response?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = async ({ searchKey }) => {
    try {
      let result = details?.filter(
        (poll) =>
          poll?.Profile?.username?.toLowerCase() === searchKey.toLowerCase() ||
          poll?.Profile?.email?.toLowerCase() === searchKey.toLowerCase() ||
          poll?.Profile?.phone?.toLowerCase() === searchKey.toLowerCase()
      );
      setNewDetails(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPolls();
  }, []);

  const columns = [
    {
      field: "Profile",
      headerName: "User Name",
      width: 150,
      renderCell: ({ row: { Profile } }) => {
        return Profile.username;
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 150,
    },
    {
      field: "isPaid",
      headerName: "Type",
      width: 100,
      renderCell: ({ row: { isPaid } }) => (
        <Typography
          color={!isPaid ? colors.greenAccent[400] : colors.redAccent[400]}
        >
          {isPaid ? "Paid" : "Free"}
        </Typography>
      ),
    },
    {
      field: "PollVotes",
      headerName: "Number of voters",
      width: 100,
      renderCell: ({ row: { PollVotes } }) => {
        return PollVotes?.length;
      },
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 100,
    },
    {
      field: "currentState",
      headerName: "Status",
      width: 100,

      renderCell: ({ row: { currentState } }) => (
        <Typography
          color={
            currentState == "activate"
              ? colors.greenAccent[400]
              : colors.redAccent[400]
          }
        >
          {currentState}
        </Typography>
      ),
    },
    {
      field: "shareCount",
      headerName: "Share",
      width: 100,
    },
    {
      field: "likeCount",
      headerName: "Likes",
      width: 100,
      renderCell: ({ row: { Post } }) => {
        return Post?.likeCount;
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 100,
    },
    {
      field: "updatedAt",
      headerName: "Last Update",
      width: 100,
    },
  ];

  return (
    <Box m="20px">
      {/* HEADER */}
      <OptionsModal
        modal={optionsModal}
        setModal={setOptionsModal}
        pollOptions={pollOptions}
        setPollOptions={setPollOptions}
      />
      <PollModal
        pollOptions={pollOptions}
        modal={modal}
        setModal={setModal}
        setOptionsModal={setOptionsModal}
        setPollOptions={setPollOptions}
      />
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ justifyContent: "space-between" }}
      >
        <Grid xs={12} sm={12} md={6} lg={3.6} xl={3}>
          <Box
            display={smScreen ? "flex" : "block"}
            flexDirection={smScreen ? "row" : "column"}
            justifyContent={smScreen ? "space-between" : "start"}
            alignItems={smScreen ? "center" : "start"}
          >
            <Header title="POLLS" subtitle="Manage Polls" />
          </Box>
        </Grid>
        <Box display="flex" height="45px" paddingRight={1.3} marginTop={1}>
          <Box display="flex">
            <SearchTable
              handleSearch={handleSearch}
              placeholder="username/email/phone"
            />
            <Button
              onClick={() => setModal({ open: true })}
              underline="none"
              sx={{
                backgroundColor: colors.orangeAccent[700],
                color: colors.grey[100],
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                marginLeft: "15px",
              }}
            >
              <SaveAsIcon sx={{ mr: "10px" }} />
              Create New Poll
            </Button>
          </Box>
        </Box>

        <Box
          m="10px"
          width="100%"
          height="70vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.orangeAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.orangeAccent[200]} !important`,
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
          }}
        >
          <DataGrid
            getRowId={(row) => {
              return row.id;
            }}
            rows={newDetails ? newDetails : []}
            columns={columns}
            // components={{ Toolbar: GridToolbar }}
          />
        </Box>
      </Grid>
    </Box>
  );
};

export default ManagePoll;
